'use client';
import { useSelector } from 'react-redux';
import Conditional from '../Conditional';
import { selectFeatureToggles } from '@next-app/lib/features/InitSelectors';
import classes from './NumericRating.module.scss';
import Link from '../elements/Link/Link';

interface INumericRatingProps {
  rating: number | string;
  customClass?: string;
  href?: string;
}

const NumericRating = ({ rating, customClass, href }: INumericRatingProps) => {
  const featureToogle = useSelector(selectFeatureToggles);
  const enhancedTypeAheadEnabled =
    featureToogle?.enhancedTypeAheadEnabled ?? false;
  return (
    <Conditional if={enhancedTypeAheadEnabled}>
      <Link
        href={href}
        className={`${customClass} ${classes['rating-text']} fs-xs lh-1`}
        style={{
          letterSpacing: '-0.18px',
          marginTop: '3px',
          marginRight: '5px',
        }}
      >
        {rating}
      </Link>
    </Conditional>
  );
};

export default NumericRating;
